<template>
  <div >
    <div class=" is-fullwidth">
     
      <div class="is-pulled-right">
        <button class="button is-warning" @click="showCompleteError()">Export to CSV</button>
      </div>
    </div>

    <p>This screen will display all requests and items which need to be completed by that particular "area". This could be artwork, print, gerber, embroidery, DTF, or any other area.</p>
    <p>So there will be multiple screens, one for each of the areas. Embroidery will have their own screen, sundries will have their own, makeup will have their own.</p>
    <div class="notification is-info" v-if="loading == true " style="clear:both">Loading requests ...</div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false">
    	<thead>
    		
        <th>ID</th>
   	 		<th>Garment</th>
          <th>Type</th>
          
          <th>Qty</th>
          <th>Extras</th>
          <th>Files</th>
          <th>Art.</th>
          <th>Digi.</th>
          <th>Trans</th>
          <th>Gerber</th>
          <th>Sundries</th>
          <th>Makeup</th>
          
    	</thead>
    	<tbody>
        <tr  class="is-selected">
          <th >1234</th>
              <th colspan="11">Bohemians FC</th>
              
            </tr>
           
          <tr>
              <td>1</td>
              <td>Clodagh 060 K20 T-Shirt</td>
              <td>Fully Printed</td>
              <td>3</td>
              <td class="">
                 <div class="tags">
                  <span class="tag ">Trims</span>
                  <span class="tag ">DTF</span>
                  <span class="tag">Silcon</span>
                </div>
              </td>
              <td><i class="fa fa-folder" aria-hidden="true"></i></td>
              <td><span class="button tag is-success">Done</span></td>
              <td><span class="button tag is-success">Done</span></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
             
          </tr>
          <tr>
              <td>2</td>
              <td>Kai 179 Gaelic Micro Stripe Training Shorts</td>
              <td>Cut/Sew</td>
              <td>1</td>
              <td class="">
                <div class="tags">
                  <span class="tag ">Emb.</span>
                </div>
              </td>
              <td><i class="fa fa-folder" aria-hidden="true"></i></td>
              <td><span class="button tag is-success">Done</span></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
             
          </tr>
          <tr>
              <td>3</td>
              <td>Printed J09 Shortsleeve K5 Jersey</td>
              <td>Strike Off</td>
              <td>4</td>
              <td class="">
                <div class="tags">
                  <span class="tag ">Emb.</span>
                  
                  <span class="tag ">DTF</span>
                  <span class="tag ">Silcon</span>
                </div>
              </td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              
          </tr>
          <tr  class="is-selected">
          <th >1346</th>
              <th colspan="11">Leigh Utd Hockey Club</th>
              
            </tr>
           
         
          <tr>
              <td>1</td>
              <td>Weston 060 K20 T-Shirt</td>
              <td>Cut/Sew</td>
              <td>1</td>
              <td class="">
                <div class="tags">
                  <span class="tag ">Emb.</span>
                </div>
              </td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
             
          </tr>
          <tr>
              <td>2</td>
              <td>Printed J09 Shortsleeve K5 Jersey</td>
              <td>Strike Off</td>
              <td>4</td>
              <td class="">
                <div class="tags">
                  <span class="tag ">Emb.</span>
                  
                </div>
              </td>
              <td><i class="fa fa-folder" aria-hidden="true"></i></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
              <td></td>
              <td></td>
              <td><span class="button tag is-success">Done</span></td>
              <td></td>
             
          </tr>
    	</tbody>
    </table>

    <div class="modal " v-bind:class="{ 'is-active' : showProcessModal} " >
            <div class="modal-background"></div>
            <div class="modal-card process" style="width:1020px">
                <header class="modal-card-head">
                <p class="modal-card-title">Process Request</p>
                <button class="delete" aria-label="close" @click="showProcessModal=false"></button>
                </header>
                <section class="modal-card-body">
              <table class="table is-fullwidth is-striped is-size-7">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Garment</th>
                          <th>Type</th>
                          <th>Qty</th>
                          <th>Extras</th>
                          <th>Print</th>
                          <th>Cutting</th>
                          <th>Makeup</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>1</td>
                          <td>Clodagh 060 K20 T-Shirt</td>
                          <td>Fully Printed</td>
                          <td>3</td>
                          <td class="">
                            <div class="tags">
                              <span class="tag">Emb.</span>
                              <span class="tag is-link">Trims</span>
                              <span class="tag is-link">DTF</span>
                              <span class="tag">Silcon</span>
                            </div>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Derry</option>
                              <option value="Strabane">Dublin</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                      </tr>
                      <tr>
                          <td>2</td>
                          <td>Kai 179 Gaelic Micro Stripe Training Shorts</td>
                          <td>Cut/Sew</td>
                          <td>1</td>
                          <td class="">
                            <div class="tags">
                              <span class="tag is-link">Emb.</span>
                              <span class="tag ">Trims</span>
                              <span class="tag ">DTF</span>
                              <span class="tag">Silcon</span>
                            </div>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Derry</option>
                              <option value="Strabane">Dublin</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                      </tr>
                      <tr>
                          <td>3</td>
                          <td>Printed J09 Shortsleeve K5 Jersey</td>
                          <td>Strike Off</td>
                          <td>4</td>
                          <td class="">
                            <div class="tags">
                              <span class="tag is-link">Emb.</span>
                              <span class="tag ">Trims</span>
                              <span class="tag is-link">DTF</span>
                              <span class="tag is-link">Silcon</span>
                              </div>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                          <td>
                            <select class="select">
                              <option>Select</option>
                              <option value="Strabane">Strabane</option>
                              <option value="Strabane">Derry</option>
                              <option value="Strabane">Dublin</option>
                              <option value="Strabane">Giurgiu</option>
                            </select>
                          </td>
                      </tr>
                      
                  </tbody>
              </table>

              <button class="button is-success" @click="showProcessModal=false">Process</button> 
            </section>
          </div>
        </div>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      cutting_location_id: 'allset',
      limit: '',
      showProcessModal: false
    }
  },
   methods: {
    showCompleteError() {
        alert("This button does not action anything. ")
    },
    viewRequest(id)
    {
        this.$router.push("/samples/view/" + id);
    },
      async getOrders() {
        this.loading=true
        OrderService.getCutSewInProgressOrders(this.accessToken, this.limit, this.order_by, this.cutting_location_id, 0, 0)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
       async updateMarker(order) {
        this.working = true
        
        var order_id = order.orderID
       

        var formdata = { 
            _method: 'patch',
             marker_received: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.marker_received = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },   
   
    
  },
  computed : {
      filteredOrders: function () {
       
        /*let filteredOrders =  this.orders.filter(function(u) {
            if(  u.in_progress == 0) 
            {
              return 1
            }
          })*/
          let filteredOrders = this.orders

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.loading = false
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    
  }
}


</script>

